document.addEventListener('click', function (event) {
    var modal = document.querySelector('.ll-reminder-modal');
    var root = document.querySelector('.ll-personalization');
    if (!modal || !root) return;

    if (event.target.closest('[data-ll-reminder-upload]')) {
        event.preventDefault();
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setTimeout(function () {
            root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
        return;
    }

    if (event.target.closest('[data-ll-reminder-close]') || event.target === modal) {
        event.preventDefault();
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        return;
    }

    var addButton = event.target.closest('button[type="submit"], button[name="add"], [id^="ProductSubmitButton-"]');
    if (!addButton) return;

    var requiredFields = root.querySelectorAll('input[required]');
    var missing = Array.prototype.some.call(requiredFields, function (field) {
        if (field.type === 'file') return !field.files || !field.files.length;
        return !field.value || !field.value.trim();
    });
    if (!missing) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
}, true);

document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('.ll-reminder-modal');
    if (event.key !== 'Escape' || !modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
});
